module.exports = __webpack_public_path__ + "img/writer-travel-3.680f99f3.png";